import { ChevronLeft } from '@mui/icons-material'
import {
  Box,
  Button,
  CircularProgress,
  Divider,
  Paper,
  Stack,
  Typography,
} from '@mui/material'
import {
  EmbeddedCheckout,
  EmbeddedCheckoutProvider,
} from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'
import { useNavigate } from 'react-router-dom'

import useT from '@/i18n/useT'

import PricingTable from './PricingTable'
import usePricingTable from './usePricingTable'

const { VITE_APP__STRIPE_PUBLISHABLE_KEY } = import.meta.env

const stripePromise = loadStripe(VITE_APP__STRIPE_PUBLISHABLE_KEY)

const SelectPlan = () => {
  const { t } = useT()
  const navigate = useNavigate()

  const {
    clientSecret,
    handleCancelCheckout,
    checkoutInfo,
    loading,
    error,
    plans,
    selectedPlan,
    handleSelectPlan,
  } = usePricingTable()

  if (selectedPlan) {
    return (
      <Stack spacing={4}>
        <Button
          variant="outlined"
          color="secondary"
          onClick={handleCancelCheckout}
          startIcon={<ChevronLeft />}
          sx={{ width: 'fit-content' }}
        >
          {t('pricingTable.backToPlans')}
        </Button>

        <Paper sx={{ p: 3 }}>
          <Typography variant="h5" gutterBottom>
            {t('pricingTable.completePurchase')}
          </Typography>
          <Typography variant="body1" color="text.secondary" gutterBottom>
            {checkoutInfo}
          </Typography>
          <Divider sx={{ my: 2 }} />
          {clientSecret ? (
            <EmbeddedCheckoutProvider
              stripe={stripePromise}
              options={{ clientSecret }}
            >
              <EmbeddedCheckout />
            </EmbeddedCheckoutProvider>
          ) : (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: 200,
              }}
            >
              <CircularProgress />
            </Box>
          )}
        </Paper>
      </Stack>
    )
  }

  return (
    <Stack spacing={4}>
      <Button
        variant="outlined"
        color="secondary"
        onClick={() => {
          navigate('/account-set-up?step=create-stores')
        }}
        sx={{ width: 'fit-content' }}
        startIcon={<ChevronLeft />}
      >
        {t('pricingTable.backToStoreSetup')}
      </Button>
      <PricingTable
        handleSelectPlan={handleSelectPlan}
        selectedPlan={selectedPlan}
        plans={plans}
        loading={loading}
        error={error}
        checkoutInfo={checkoutInfo}
      />
    </Stack>
  )
}

export default SelectPlan
